import {Component, Input, OnInit, ViewChild} from '@angular/core';

declare let Blockly;

@Component({
  selector: 'blockly-read-only',
  templateUrl: './read-only.component.html',
  styleUrls: ['./read-only.component.scss']
})
export class ReadOnlyComponent implements OnInit {

  workspace: any;
  @Input() input: any;
  @Input() inputType = 'blockly_xml'; // blockly_xml or block_type

  @ViewChild('blockly') blocklyContainer;

  constructor() { }

  ngOnInit() {

    if (this.inputType === 'block_type') {
      this.input = '<xml xmlns=\"https://developers.google.com/blockly/xml\"><block type=\"' + this.input + '\"></block></xml>';
    }

    if (this.inputType === 'blocky_xml') {
      let blockText = this.input;
      const parser = new DOMParser();
      const xml1 = parser.parseFromString(blockText, 'text/xml');
      var xmlNode = xml1.getElementsByTagName('xml');
      if (xmlNode) {
        for (var i = 0; i < xmlNode.length; i++) {
          for (var j = 0; j < xmlNode[i].childNodes.length; j++) {
            var el = xmlNode[i].childNodes[j];
            if (el.childNodes.length !== 1) {
              blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + Blockly.Xml.domToText(el) + '</xml>';
            }
          }
        }
      } else {
        blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + blockText + '</xml>';

      }

      this.input = blockText;
    }

    if (this.input && this.input !== '') {
      if (this.blocklyContainer) {
        this.initBlockly();
      } else {
        const observer = new MutationObserver((mutations, obs) => {
          const blocklyDiv = this.blocklyContainer;
          if (blocklyDiv) {
            obs.disconnect();
            this.initBlockly();
            return;
          }
        });
        observer.observe(document, {
          childList: true,
          subtree: true
        });
      }
    }
  }

  initBlockly() {
    this.workspace = Blockly.inject(this.blocklyContainer.nativeElement, {
      comments: false,
      toolbox: false,
      trashcan: false,
      readOnly: false,
      scrollbars: false,
      sounds: false,
    });

    this.loadXML(this.workspace, this.input);
    const blockObjects = this.workspace.getAllBlocks(true);
    for (const block of blockObjects) {
      if (!block.rendered) {
        block.dispose();
      } else {
        // block.setDeletable(false);
        // block.setEditable(false);
        // block.setMovable(false);
      }
    }

    this.customFitBlocks();
  }

  customFitBlocks() {
    let metrics = this.workspace.getMetrics();
    const blocksEditor = this.blocklyContainer.nativeElement;

    let zoomChanged = false;
    while (metrics.contentWidth > blocksEditor.offsetWidth) {
      this.workspace.zoomCenter(-0.1);
      metrics = this.workspace.getMetrics();
      zoomChanged = true;
    }
    if (!zoomChanged) {
      this.workspace.zoomCenter(-0.7);
    }

    blocksEditor.style.height = metrics.contentHeight + 'px';
    blocksEditor.style.width = metrics.contentWidth + 'px';
    Blockly.svgResize(this.workspace);
    this.workspace.zoomToFit();

    const blockObjects = this.workspace.getAllBlocks(true);
    for (const block of blockObjects) {
      block.setDeletable(false);
      block.setEditable(false);
      block.setMovable(false);
    }
  }

  loadXML(workspace, xml) {
    if (typeof xml !== 'string' || xml.length < 5) {
      return false;
    }
    try {
      const dom = Blockly.Xml.textToDom(xml);
      Blockly.mainWorkspace.clear();
      Blockly.Xml.domToWorkspace(dom, workspace);
      return true;
    } catch (e) {
      return false;
    }
  }
}
